/**
 * Las dos pestañas de "Análisis de datos".
 *
 * Son DATO, no ramas de render: cada pestaña ES una de las rutas que ya
 * existían como pantalla suelta. Fusionar Insights y Estrategia en una sola
 * pantalla NO estrenó una URL — `/estudio-marketing/insights` y
 * `/estudio-marketing/estrategia` siguen siendo direcciones vivas, así que los
 * cinco `destino` que el mapa apunta ahí siguen andando sin tocar
 * `grafo/definicion.ts` ni `RUTAS_VALIDAS`, y cualquier link ya compartido
 * también (ADR-2026-08-17-analisis-datos-tabs-por-ruta).
 *
 * Corolario: la pestaña activa se DERIVA de la URL. No hay estado local que
 * pueda desincronizarse, y entrar directo por cualquiera de las dos deja al
 * usuario parado en la correcta.
 */

export interface TabAnalisis {
  /** Sufijo estable para los `id` del par tab/tabpanel de ARIA. */
  id: string;
  etiqueta: string;
  ruta: string;
}

export const TABS_ANALISIS: readonly TabAnalisis[] = [
  {
    id: "insights",
    etiqueta: "Insights",
    ruta: "/estudio-marketing/insights",
  },
  {
    id: "estrategia",
    etiqueta: "Estrategia de contenido",
    ruta: "/estudio-marketing/estrategia",
  },
];

/** Las rutas que el ítem fusionado del Sidebar tiene que sentir como propias. */
export const RUTAS_ANALISIS: readonly string[] = TABS_ANALISIS.map((tab) => tab.ruta);

/**
 * Ruta → pestaña. Cae en la primera si la ruta no es ninguna de las dos: el
 * contenedor solo se monta sobre sus propias rutas, así que ese caso no pasa
 * en la app, pero devolver algo siempre evita que un `undefined` se filtre al
 * render.
 */
export function tabActivaSegunRuta(pathname: string): TabAnalisis {
  const limpia = pathname.replace(/\/+$/, "");
  return TABS_ANALISIS.find((tab) => tab.ruta === limpia) ?? TABS_ANALISIS[0];
}

/**
 * Vecina para las flechas del teclado, con vuelta en los extremos (patrón
 * `tablist` de WAI-ARIA). `paso` +1 va a la derecha, -1 a la izquierda.
 */
export function tabPorDesplazamiento(idActual: string, paso: number): TabAnalisis {
  const indice = TABS_ANALISIS.findIndex((tab) => tab.id === idActual);
  const total = TABS_ANALISIS.length;
  const desde = indice === -1 ? 0 : indice;
  const siguiente = (((desde + paso) % total) + total) % total;
  return TABS_ANALISIS[siguiente];
}
